import Cookies from "js-cookie";
import {jwtDecode} from "jwt-decode"; // Correct import for jwtDecode

// Function to get the user role from the token stored in cookies
export const getUserRole = () => {
  const token = Cookies.get("access_token");
  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken.role?.role_name || null; // Return role_name or null
    } catch (error) {
      console.error("Failed to decode token", error);
      return null;
    }
  }
  return null;
};

// Function to check user permissions
export const checkPermission = (requiredRole, userRole) => {
  if (!requiredRole || !Array.isArray(requiredRole)) {
    console.error("Invalid requiredRole:", requiredRole);
    return false; // If no permission is required or requiredRole is invalid, do not display the route
  }
  if (!userRole) return false;

  // Check if the user has one of the required roles
  return requiredRole.some((role) => role === userRole);
};